// extracted by mini-css-extract-plugin
export default {"fullScreen":"modal_fullScreen__qrE67"};